import type { FC } from 'react';

import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { ResponseType as ChoiceResponseType } from '../../types/enum';

import { track } from '@helsenorge/framework-utils/amplitude';
import { UtfortHandling } from '@helsenorge/framework-utils/amplitude/ampli';

import { Button } from '../../components/button';
import { Title } from '../../components/title';
import { Wrapper } from '../../components/wrapper';
import ContentWrapper from '../../components/wrapper/content';
import WrapperInner from '../../components/wrapper/inner';
import { useAppSelector } from '../../redux/hooks';
import { selectIntroChoiceUrl, selectPage } from '../../redux/selectors';
import { setAnsweredIntro } from '../../redux/selvtestSlice';
import { harQuizInngang } from '../../utils/helper';
import { safeNavigate } from '../../utils/navigate';

export const HvemErDu: FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pageContent = useAppSelector(state => selectPage(state, location.pathname));
  const introChoiceUrl = useAppSelector(selectIntroChoiceUrl);
  const quiz = harQuizInngang(introChoiceUrl);
  const path = quiz ? '/quizinngang' : introChoiceUrl;
  const temaTitle = pageContent?.title;
  const choices = pageContent?.choices;
  const navigate = useNavigate();

  return (
    <Wrapper
      onClickBack={() => {
        navigate(-1);
      }}
    >
      <WrapperInner>
        <Title>{temaTitle}</Title>

        <ContentWrapper>
          {choices &&
            choices.map((tema, index) => {
              return (
                <Button
                  key={index}
                  color={quiz ? 'inverted' : 'normal'}
                  onClick={() => {
                    if (pageContent.analyticsId) {
                      track(
                        new UtfortHandling({
                          handling: 'velge',
                          objekt: `${pageContent.analyticsId}: ${tema.text}`,
                          tjeneste: 'hvaerinnafor',
                        })
                      );
                    }
                    if (tema.responseType === ChoiceResponseType.introending) {
                      dispatch(setAnsweredIntro(true));
                      safeNavigate(navigate, path ?? tema.navigateTo);
                    } else {
                      safeNavigate(navigate, tema.navigateTo);
                    }
                  }}
                >
                  {tema.text}
                </Button>
              );
            })}
        </ContentWrapper>
      </WrapperInner>
    </Wrapper>
  );
};
export default HvemErDu;
